import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import {  setUnAuthenticated } from "../actions/auth";

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        authenticated: state.auth.authenticated,
        user: state.auth.user,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    setUnAuthenticated
}, dispatch);

const AuthContainer = (component: any) => {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

export default AuthContainer;